import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import moment from 'moment';
import '../../index.scss';
import './tournamentCollection.css';

class TournamentCollection extends Component {

    getTournamentDateString(tp) {
        const start = moment(tp.startDate);
        const stop = moment(tp.endDate);
    
        var final = '';
        if (start.year() === stop.year()) {
            if (start.month() === stop.month()) {
                final = `${start.format('MMMM D')} - ${stop.format('D, YYYY')}` 
            } else {
                final = `${start.format('MMMM D')} - ${stop.format('MMMM D, YYYY')}` 
            }
        } else {
            final = `${start.format('MMMM D, YYYY')} - ${stop.format('MMMM D, YYYY')}` 
        }
    
        return final;
    }
    
    insideLink(childItem) {

        return childItem.imageUrl != null && childItem.imageUrl.trim() && (
            <div className="collection-banner p-left">
                <div className="img-part">
                        <img src={`${childItem.imageUrl}?` + new Date().getTime()} className="sizedThumbImg img-fluid blur-up lazyload bg-img img-thumbnail" alt="" />
                    <br/>
                </div>
            </div>
        )
    }

    render () {    
        const backgroundColor = "#88aa88"
        return (
            <section className="pt-0 banner-6 ratio2_1">
                    <div className="row partition3">
                        { this.props.item && this.props.item.items.map((childItem, index ) => 
                            <div key={index} className={this.props.cols}>
                                    <div className="card" style={{background: backgroundColor}}>
                                        <div className="card-header" style={{background: backgroundColor, paddingTop: "14px", paddingBottom: "0px", border: "none"}}>
                                            <Link to={`${process.env.PUBLIC_URL}${childItem.link}`}>    
                                                <h4 style={{color: "black", fontFamily: "serif", marginBottom: "2px"}}>{childItem.name}</h4> 
                                                <p style={{color: "black", fontSize: "14px", fontFamily: "serif"}}>{this.getTournamentDateString(childItem.tp)}</p>                                
                                            </Link>
                                        </div>

                                        <div className="card-body" style={{paddingTop: "0px", paddingBottom: "0px", margin: "0px"}}>
                                            <Link to={`${process.env.PUBLIC_URL}${childItem.link}`}>
                                                {this.insideLink(childItem)}
                                            </Link>
                                        </div>

                                        <div className="card-footer" style={{background: backgroundColor, paddingTop: "0px", paddingBottom: "0px", border: "none"}}>
                                            <div style={{padding: '8px'}}>
                                                {childItem.tp.myRole === "isCompetitor" &&
                                                    <i className="fa fa-comments" aria-hidden="true"></i>
                                                }
                                                                                                
                                                {childItem.tp.myRole === "isJudge"  &&
                                                    <i className="fa fa-gavel" aria-hidden="true"></i>
                                                }

                                                {childItem.tp.myRole === "isAdmin"  &&
                                                    <i className="fa fa-cogs" aria-hidden="true"></i>
                                                }

                                                {childItem.tp.myRole === "isGuest"  &&
                                                    <i className="fa fa-eye" aria-hidden="true"></i>
                                                }
                                            </div> 
                                        </div>
                                    </div>
                            </div>
                        )}           
                    </div>
            </section>
        )
    }
}

export default TournamentCollection;